import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Translation } from "react-i18next";
import { FormGroup, Form, Input, Row, Col, ButtonGroup, Button } from "reactstrap";
 
import { updateComponent,updateList } from '_actions';
import { findObjUpdate,findNestedObjAndChangeALL } from 'assets/util';



import {
    PropertyTitle,
} from "../Core/";

import ColorPicker from "../Core/ColorPicker";

import BorderSize from "../Core/BorderSize"
import BorderRadius from "../Core/BorderRadius"
import MarginProperty from "../Core/MarginProperty"
import PaddingProperty from "../Core/PaddingProperty"
import SizeProperty from "../Core/SizeProperty"
import SliderProperty from "../Core/SliderProperty"
import ImageProperty from "../Core/ImageProperty"


/* plugins */
import Slider from "nouislider";
import Select2 from "react-select2-wrapper";


class LayoutSettings extends Component {
    constructor(props) {
        super(props)
        this.fontSizeSlider = React.createRef();

        const { component } = props;
        const { object } = component.hasOwnProperty("componentOwner") ? component.object.components[0] : component.components[0];
        const { style } = object.props;

        this.state = {
            componentClone: component,
            backgroundColor: component && (style["backgroundColor"] == undefined ? "rgba(255, 255, 255, 0)" : style["backgroundColor"]),
            borderColor: component && (style["borderColor"] == undefined ? "rgba(255, 255, 255, 0)" : style["borderColor"]),

        }

    }

    handleUpdateEditor = (_clone) => {

        /*
            state eski halinden farklı ise güncelleme gönderilmeli..

            
        */
       this.props.updateList(findNestedObjAndChangeALL(this.props.editor, _clone.id, _clone));
    }

    handleChangeBackgroundColor = (color) => {
        this.setState({
            backgroundColor: color,
        }, () => {
            let _clone = Object.assign({}, this.props.component);
            if (_clone.hasOwnProperty("componentOwner")) {
                _clone.object.components[0].object.props.style = {
                    ..._clone.object.components[0].object.props.style,
                    backgroundColor: `rgba(${this.state.backgroundColor.r}, ${this.state.backgroundColor.g}, ${this.state.backgroundColor.b}, ${this.state.backgroundColor.a})`
                }
            } else {
                _clone.components[0].object.props.style = {
                    ..._clone.components[0].object.props.style,
                    backgroundColor: `rgba(${this.state.backgroundColor.r}, ${this.state.backgroundColor.g}, ${this.state.backgroundColor.b}, ${this.state.backgroundColor.a})`
                }
            }
            let _newEditor = JSON.parse(JSON.stringify(this.props.editor))
            let _result = findObjUpdate(_newEditor, _clone);
            this.props.updateComponent(_clone);
            this.props.onUpdateList(_result);
            
        })
    }

    handleChangeBorderColor = (color) => {
        this.setState({
            borderColor: color,
        }, () => {
            let _clone = Object.assign({}, this.props.component);
            if (_clone.hasOwnProperty("componentOwner")) {
                _clone.object.components[0].object.props.style = {
                    ..._clone.object.components[0].object.props.style,
                    borderColor: `rgba(${this.state.borderColor.r}, ${this.state.borderColor.g}, ${this.state.borderColor.b}, ${this.state.borderColor.a})`
                }
            } else {
                _clone.components[0].object.props.style = {
                    ..._clone.components[0].object.props.style,
                    borderColor: `rgba(${this.state.borderColor.r}, ${this.state.borderColor.g}, ${this.state.borderColor.b}, ${this.state.borderColor.a})`
                }
            }
            let _newEditor = JSON.parse(JSON.stringify(this.props.editor))
            let _result = findObjUpdate(_newEditor, _clone);
            this.props.updateComponent(_clone);
            this.props.onUpdateList(_result);
        })
    }



    componentDidUpdate = (prevProps) => {

        const { component } = this.props;
        const { object } = component.hasOwnProperty("componentOwner") ? component.object.components[0] : component.components[0];
        const { style } = object.props;

        if (prevProps.component != component) {
            this.setState({
                backgroundColor: style["backgroundColor"] == undefined ? "rgba(255, 255, 255, 0)" : style["backgroundColor"],
                borderColor: style["borderColor"] == undefined ? "rgba(255, 255, 255, 0)" : style["borderColor"],

            }, () => {


            })
        }
    }


    componentDidMount() {
    }

    render() {
        const { component } = this.props;
        const { object } = component.hasOwnProperty("componentOwner") ? component.object.components[0] : component.components[0];

        return (
            <Translation>
                {t => (
                    <Form>
                        <FormGroup className={"property-form-group"}>
                            <PropertyTitle title={t("PROPERTY_LAYOUT_WIDTH")} subtitle={""} />
                            <SizeProperty propName={"minWidth"} />
                        </FormGroup>
                        <FormGroup className={"property-form-group"}>
                            <PropertyTitle title={t("PROPERTY_LAYOUT_HEIGHT")} subtitle={""} />
                            <SizeProperty propName={"minHeight"} />
                        </FormGroup>
                        <FormGroup className={"property-form-group"}>
                            <PropertyTitle title={t("PROPERTY_LAYOUT_MARGIN")} subtitle={""} />
                            <MarginProperty />
                        </FormGroup>
                        <FormGroup className={"property-form-group"}>
                            <PropertyTitle title={t("PROPERTY_LAYOUT_PADDING")} subtitle={""} />
                            <PaddingProperty />
                        </FormGroup>
                        <FormGroup className={"property-form-group"}>
                            <div className={"propertyTitleDiv"}>
                                <label htmlFor="exampleFormControlInput1" className={"propertyTitle"}>{t("PROPERTY_LAYOUT_BACKGROUNDCOLOR")}
                                </label>
                                <ColorPicker isComponent={true} id={"background-color"} color={this.state.backgroundColor} handle={this.handleChangeBackgroundColor} />
                            </div>
                        </FormGroup>


                        <FormGroup className={"property-form-group"}>
                            <PropertyTitle title={t("PROPERTY_LAYOUT_BORDER_WIDTH")} subtitle={""} />
                            <BorderSize />
                        </FormGroup>
                        <FormGroup className={"property-form-group"}>
                            <div className={"propertyTitleDiv"}>
                                <label htmlFor="exampleFormControlInput1" className={"propertyTitle"}>{t("PROPERTY_LAYOUT_BORDERCOLOR")}
                                </label>
                                <ColorPicker isComponent={true} id={"border-color"} color={this.state.borderColor} handle={this.handleChangeBorderColor} />
                            </div>
                        </FormGroup>
                        <FormGroup className={"property-form-group"}>
                            <PropertyTitle title={t("PROPERTY_LAYOUT_BORDER_RADIUS")} subtitle={""} />
                            <BorderRadius />
                        </FormGroup>
                        <FormGroup className={"property-form-group"}>
                            <PropertyTitle title={t("PROPERTY_LAYOUT_OPACITY")} subtitle={this.props.component ? object.props.style.opacity : ""} />
                            <SliderProperty propName={"opacity"} min={0} max={1} step={.1} type={""} current={1} />
                        </FormGroup>

                    </Form>
                )}
            </Translation>
        )
    }
}

//export default InputGenerator
const mapStateToProps = (state) => {
    const { componentReducer, editorReducer } = state;
    const { component } = componentReducer;

    const { present } = editorReducer;
    const { editor } = present;
    return {
        editor,
        component,
    };
}
const mapDispatchToProps = {
    updateComponent,
    updateList,
    onUpdateList: updateList,

}
export default connect(mapStateToProps, mapDispatchToProps)(LayoutSettings)
